import {Component, ElementRef} from '@angular/core';
import {Location} from '@angular/common';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TemporaryScoreService} from '../../services/temporary-score.service';
import {Router} from '@angular/router';
import {alphanumericValidator} from '../sign-up/sign-up.component';
import {ScoreService} from '../../services/score.service';

@Component({
  selector: 'tech-core-quiz-score-intro',
  standalone: false,
  templateUrl: './score-intro.component.html',
  styleUrl: './score-intro.component.scss'
})
export class ScoreIntroComponent {

  public userData: FormGroup
  public userInput: FormControl<string | null>;

  constructor(
    private location: Location,
    public fb: FormBuilder,
    public scoreService: ScoreService,
    public router: Router,
    private el: ElementRef
  ) {

    this.userInput = new FormControl('', [Validators.required, alphanumericValidator(), Validators.maxLength(12)]);

    this.userData = this.fb.group({
      userInput: this.userInput,
    })

  }


  confirm() {
    if (this.userInput.valid) {
      let userName = this.userInput.value!;

      this.scoreService.getUserScoreWithRank(userName).subscribe({
        next: (response) => {
          this.router.navigate(["/score"], {queryParams: {userName: userName}});
        },
        error: (err) => {
          if (err.status === 404) {
            this.userInput.setErrors({userNameNotFound: true});
          } else {
            console.error(err);
          }
        }
      });
    }
  }

  isEnabled() {
    return !this.userInput.valid;
  }

  navigateBack() {
    this.location.back();
  }

  navigateToScore() {
    this.router.navigate(['/score']);
  }

  hasError() {
    if (!this.userInput.touched && !this.userInput.dirty) {
      return false;
    }

    return this.userInput.hasError('required') ||
      this.userInput.hasError('alphanumeric') ||
      this.userInput.hasError('userNameNotFound') ||
      this.userInput.hasError('maxlength');
  }

  changeError() {
    if (this.userInput.hasError('required')) {
      return "Username is required";
    }

    if (this.userInput.hasError('alphanumeric')) {
      return "Username can only contain letters and numbers";
    }

    if (this.userInput.hasError('userNameNotFound')) {
      return "Username does not exist";
    }

    if (this.userInput.hasError('maxlength')) {
      return "Username can only be 12 letter long";
    }

    return "Error";
  }

}
